import { rePossibleCharacteristicConstants } from "./constants"
import actions from '../../../actions'

const initialState = {
	isSending  : false,
	list       : [],
	paged      : {},
	pagedAudit : {},
	changed    : null
}

export default function (state = initialState, action){
	switch (action.type){
		case rePossibleCharacteristicConstants.GetList.REQUEST:
		case rePossibleCharacteristicConstants.GetPaged.REQUEST:
		case rePossibleCharacteristicConstants.GetPagedAll.REQUEST:
		case rePossibleCharacteristicConstants.GetPagedAudit.REQUEST:
		case rePossibleCharacteristicConstants.Create.REQUEST:
		case rePossibleCharacteristicConstants.Delete.REQUEST:
		case rePossibleCharacteristicConstants.Restore.REQUEST:
		case rePossibleCharacteristicConstants.Update.REQUEST:
			return {
				...state,
				isSending : true,
				changed   : null
			}
		case rePossibleCharacteristicConstants.GetList.FAILURE:
		case rePossibleCharacteristicConstants.GetPaged.FAILURE:
		case rePossibleCharacteristicConstants.GetPagedAll.FAILURE:
		case rePossibleCharacteristicConstants.GetPagedAudit.FAILURE:
		case rePossibleCharacteristicConstants.Create.FAILURE:
		case rePossibleCharacteristicConstants.Delete.FAILURE:
		case rePossibleCharacteristicConstants.Restore.FAILURE:
		case rePossibleCharacteristicConstants.Update.FAILURE:
			return {
				...state,
				isSending : false,
				error     : action.payload,
				changed   : null
			}
		case rePossibleCharacteristicConstants.GetPaged.SUCCESS:
		case rePossibleCharacteristicConstants.GetPagedAll.SUCCESS:
			return {
				...state,
				isSending : false,
				paged     : action.payload.result
			}
		case rePossibleCharacteristicConstants.GetPagedAudit.SUCCESS:
			return {
				...state,
				isSending  : false,
				pagedAudit : action.payload.result
			}
		case rePossibleCharacteristicConstants.GetList.SUCCESS:
			return {
				...state,
				isSending : false,
				list      : action.payload.result
			}
		case rePossibleCharacteristicConstants.Create.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.create : null
			}
		case rePossibleCharacteristicConstants.Delete.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.delete : null
			}
		case rePossibleCharacteristicConstants.Update.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.update : null
			}
		case rePossibleCharacteristicConstants.Restore.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.restore : null
			}
		case rePossibleCharacteristicConstants.CLEAR:
			return {
				...state,
				isSending  : false,
				list       : [],
				changed    : null,
				paged      : {},
				pagedAudit : {}
			}
		default:
			return state
	}
}